// extracted by mini-css-extract-plugin
export default {"barLabel":"task-list_barLabel__gcJY2","barLabelOutside":"task-list_barLabelOutside__pFn+M"};